module.exports = __webpack_public_path__ + "img/txbb.f334f301.jpg";